const Index = () => {
  return (
    <div>
      Home Page
    </div>
  )
}

export default Index
